import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "install-success" }
const _hoisted_2 = { class: "success-content" }
const _hoisted_3 = { class: "next-steps" }
const _hoisted_4 = { class: "options-grid" }
const _hoisted_5 = { class: "option-card dashboard-option" }
const _hoisted_6 = { class: "option-card slack-option" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "success-header" }, [
        _createElementVNode("div", { class: "success-icon" }, "🎉"),
        _createElementVNode("h1", null, "Congratulations! Prec8 is now installed!"),
        _createElementVNode("p", { class: "success-subtitle" }, " Your team is ready to start recognizing each other and building a culture of appreciation. ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("h2", null, "What would you like to do next?", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "option-icon" }, "📊", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Go to Dashboard", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", null, "Set up your team's appreciation emoji, configure settings, and start managing your workspace.", -1)),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToDashboard && _ctx.goToDashboard(...args))),
              class: "option-button dashboard-button"
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("span", null, "Open Dashboard", -1),
              _createElementVNode("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M7 17L17 7M17 7H7M17 7V17",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "option-icon" }, "💬", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Go to Slack", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", null, "Jump back to Slack to start giving recognition to your teammates right away.", -1)),
            _createElementVNode("a", {
              href: _ctx.launchSlackUrl,
              class: "option-button slack-button"
            }, [...(_cache[5] || (_cache[5] = [
              _createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 122.8 122.8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z\" fill=\"#e01e5a\"></path><path d=\"M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z\" fill=\"#36c5f0\"></path><path d=\"M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z\" fill=\"#2eb67d\"></path><path d=\"M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z\" fill=\"#ecb22e\"></path></svg><span>Open Slack</span>", 2)
            ]))], 8, _hoisted_7)
          ])
        ])
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "quick-tips" }, [
        _createElementVNode("h3", null, "💡 Quick Tips"),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, "Use your team's custom emoji to give recognition in any Slack channel"),
          _createElementVNode("li", null, "Check the leaderboard to see who's getting the most appreciation"),
          _createElementVNode("li", null, "Redeem points for rewards in the rewards store")
        ])
      ], -1))
    ]),
    _createVNode(_component_Footer)
  ]))
}